/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandRuleSetInput
 */
export interface GoogleSearchConsoleBrandRuleSetInput {
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleBrandRuleSetInput
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleBrandRuleSetInput
     */
    terms?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleBrandRuleSetInput
     */
    reason?: string;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandRuleSetInput interface.
 */
export function instanceOfGoogleSearchConsoleBrandRuleSetInput(value: object): value is GoogleSearchConsoleBrandRuleSetInput {
    return true;
}

export function GoogleSearchConsoleBrandRuleSetInputFromJSON(json: any): GoogleSearchConsoleBrandRuleSetInput {
    return GoogleSearchConsoleBrandRuleSetInputFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandRuleSetInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandRuleSetInput {
    if (json == null) {
        return json;
    }
    return {
        
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'terms': json['terms'] == null ? undefined : json['terms'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GoogleSearchConsoleBrandRuleSetInputToJSON(json: any): GoogleSearchConsoleBrandRuleSetInput {
    return GoogleSearchConsoleBrandRuleSetInputToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandRuleSetInputToJSONTyped(value?: GoogleSearchConsoleBrandRuleSetInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'terms': value['terms'],
        'reason': value['reason'],
    };
}

